"use client";
import { useCallback } from "react";
import { useLang } from "@/providers/langProvider";
import { getTranslation } from "@/utils/helpers/getTranslations";

/**
 * Resolves merchant-authored copy from the API for the active locale.
 *
 * The admin stores these fields either as a plain string (the merchant filled in
 * one language) or as a JSON map — `{"en":"Matching products","ar":"المنتجات الموافقة والمكملة"}`.
 * `getTranslation` handles both, and falls back to whichever language the
 * merchant *did* fill in, so a title never renders blank because one locale is
 * missing.
 *
 * This is the tenant-copy path (AGENTS §8) — distinct from `useTranslation`,
 * which serves our own built-in UI labels from `hooks/localization/{en,ar}.json`.
 */
export const useTenantText = () => {
  const lang = useLang();
  return useCallback(
    (value?: string | null): string =>
      value ? ((getTranslation(value, lang) as string | undefined) ?? "") : "",
    [lang],
  );
};
